


















































import { Vue, Component, Prop } from "vue-property-decorator";
import CatalogueSettingSelect from "@/components/CatalogueSettings/Select.vue";
import { catalogueSettings } from "@/models/Setting";
import QuotationStatusSelect from "@/components/Quotation/StatusSelect.vue";
import { firstLowerCase, camelToUnderscore } from "../../utils/Typography";
import ClientSelect from "@/components/Client/Select.vue";
import CompanyFamilyShow from "@/views/CompanyFamily/Show.vue";

@Component({
  components: {
    CatalogueSettingSelect,
    QuotationStatusSelect,
    ClientSelect,
  },
})
export default class Filters extends Vue {
  @Prop({ default: false }) readonly clientView!: boolean;

  private filter = {};
  get selects() {
    return catalogueSettings;
  }

  mounted() {
    this.filter = { ...this.$route.query };
    this.apply();
  }

  apply() {
    this.$emit("apply", { filter: this.filter });
  }

  selectedValue(key: string) {
    return this.$route.query[key] ? this.$route.query[key] : null;
  }

  reset() {
    this.$emit("reset");
    this.filter = {};
  }

  onFilterChanged(rawKey: string, value: string) {
    const key = camelToUnderscore(rawKey);
    if (!value || value === "all") {
      delete this.filter[key];
    } else {
      this.filter[key] = value;
    }
  }
}
